// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import axios from 'axios'
import { post } from './api/http'
import md5 from 'js-md5'
import global from './common/js/global'
import globalVar from './common/js/global_variable'
import Mint from 'mint-ui'
import encrypt from './common/js/encrypt'
import VueCookies from 'vue-cookies';

Vue.config.productionTip = false

import 'lib-flexible'
import 'mint-ui/lib/style.css'
import '../static/css/reset.css'
import '../static/css/main.css'

let appkey = decodeURIComponent((new RegExp('[?|&]' + 'appkey' + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
let auth_code = decodeURIComponent((new RegExp('[?|&]' + 'auth_code' + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
let txid = decodeURIComponent((new RegExp('[?|&]' + 'txid' + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
console.log("appkey:", appkey)
console.log("auth_code:", auth_code)


Vue.prototype.$axios = axios;
Vue.prototype.$post = post;
Vue.prototype.$md5 = md5;
Vue.prototype.$encrypt = encrypt
Vue.prototype.$global = globalVar;
Vue.prototype.$global.appkey = appkey;
Vue.prototype.$global.txid = txid;
if (appkey) {
    localStorage.setItem("appkey", JSON.stringify(appkey));
}
if (auth_code) {
    localStorage.setItem("auth_code", JSON.stringify(auth_code));
    localStorage.setItem("hasLogged", JSON.stringify(true));
}
if (txid) {
    localStorage.setItem("txid", JSON.stringify(txid));
}

// let domainTxt = window.location.host
let domainTxt = window.location.hostname
let domainType = domainTxt.slice(domainTxt.indexOf(".") + 1)
Vue.prototype.$global.domainType = domainType;
console.log("domainType: ", domainType)



Vue.use(global);
Vue.use(Mint);
Vue.use(VueCookies);

router.beforeEach((to, from, next) => {
    if (to.query.target) {
        VueCookies.set('target',to.query.target, "0");
    }
    if (to.meta.isKfc) {
        localStorage.setItem("isKfc", JSON.stringify(true));
    } else {
        localStorage.removeItem("isKfc");
    }
    next()
})

router.beforeEach((to, from, next) => {
    if (to.meta.requireAuth) {
        if (to.path != '/logup' && to.path != '/' && window.localStorage.getItem('hasLogged') && window.localStorage.getItem('auth_code')) {
            next();
        } else {
            Mint.Toast({
                message: '请先登录！',
                position: 'middle',
                duration: 2000,
                className: 'toastBox'
            });
            let isKfc = to.meta.isKfc ? to.meta.isKfc : ""
            next({
                path: '/logup',
                query: { redirect: to.fullPath, isKfc: isKfc }
            })
        }
    } else {
        next({
            query: { redirect: to.fullPath }
        });
    }
});

if (appkey && appkey == 'ykdyp134') {
    document.title = '悦看电影票'
    localStorage.setItem("serviceNo", JSON.stringify('400-126-0606'));
} else if (appkey && appkey == 'yxmoviex') {
    document.title = '悦享电影'
    localStorage.setItem("serviceNo", JSON.stringify('400-126-0606'));
} else {
    localStorage.setItem("serviceNo", JSON.stringify('400-820-1350'));
    router.beforeEach((to, from, next) => {
        /* 路由发生变化修改页面title */
        if (to.meta.title) {
            document.title = to.meta.title
        } else {
            document.title = ""
        }
        next()
    })
}





window.onresize = setHtmlFontSize;

function setHtmlFontSize() {
    const htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
    const htmlDom = document.getElementsByTagName('html')[0];
    htmlDom.style.fontSize = htmlWidth / 10 + 'px';
};
setHtmlFontSize();

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})

Vue.filter('formatTime', function(val) {
    return val.slice(11, 16)
})

Vue.filter('formatDate', function(val) {
    let date = new Date(val)
    let weekDayArr = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"]
    let weekDay = date.getDay() //获取当前星期X(0-6,0代表星期天)
    let month = date.getMonth() + 1 //获取当前星期X(0-6,0代表星期天)
    let day = date.getDate() //获取当前星期X(0-6,0代表星期天)
    return month + '月' + day + '日（' + weekDayArr[weekDay] + '）'
})

Vue.filter('formatDistance', function(val) {
    if (!val) {
        return ""
    } else {
        return (val / 1000).toFixed(2)
    }
})


// WEBPACK FOOTER //
// ./src/main.js